import { useState } from "react";
import { Menu, Button } from "antd";
import { Link, NavLink, useLocation } from "react-router-dom";
import logo from "../../assets/images/logo.png";
import {
  AppstoreAddOutlined,
  FileProtectOutlined,
  FolderAddOutlined,
  FolderViewOutlined,
  PlusSquareOutlined,
  ShopOutlined,
  UnorderedListOutlined,
  UserAddOutlined,
} from "@ant-design/icons";

function Sidenav({ color }) {
  const { pathname } = useLocation();
  const page = pathname.replace("/", "");

  const dashboard = [
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      key={0}
    >
      <path
        d="M3 4C3 3.44772 3.44772 3 4 3H16C16.5523 3 17 3.44772 17 4V6C17 6.55228 16.5523 7 16 7H4C3.44772 7 3 6.55228 3 6V4Z"
        fill={color}
      ></path>
      <path
        d="M3 10C3 9.44771 3.44772 9 4 9H10C10.5523 9 11 9.44771 11 10V16C11 16.5523 10.5523 17 10 17H4C3.44772 17 3 16.5523 3 16V10Z"
        fill={color}
      ></path>
      <path
        d="M14 9C13.4477 9 13 9.44771 13 10V16C13 16.5523 13.4477 17 14 17H16C16.5523 17 17 16.5523 17 16V10C17 9.44771 16.5523 9 16 9H14Z"
        fill={color}
      ></path>
    </svg>,
  ];

  const tables = [
    <svg
      width="22"
      height="22"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      key={0}
    >
      <path
        d="M9 6C9 7.65685 7.65685 9 6 9C4.34315 9 3 7.65685 3 6C3 4.34315 4.34315 3 6 3C7.65685 3 9 4.34315 9 6Z"
        fill="#fff"
      ></path>
      <path
        d="M17 6C17 7.65685 15.6569 9 14 9C12.3431 9 11 7.65685 11 6C11 4.34315 12.3431 3 14 3C15.6569 3 17 4.34315 17 6Z"
        fill="#fff"
      ></path>
      <path
        d="M12.9291 17C12.9758 16.6734 13 16.3395 13 16C13 14.3648 12.4393 12.8606 11.4998 11.6691C12.2352 11.2435 13.0892 11 14 11C16.7614 11 19 13.2386 19 16V17H12.9291Z"
        fill="#fff"
      ></path>
      <path
        d="M6 11C8.76142 11 11 13.2386 11 16V17H1V16C1 13.2386 3.23858 11 6 11Z"
        fill="#fff"
      ></path>
    </svg>,
  ];

  const billing = [
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      key={0}
    >
      <path
        d="M4 4C2.89543 4 2 4.89543 2 6V7H18V6C18 4.89543 17.1046 4 16 4H4Z"
        fill={color}
      ></path>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18 9H2V14C2 15.1046 2.89543 16 4 16H16C17.1046 16 18 15.1046 18 14V9ZM4 13C4 12.4477 4.44772 12 5 12H6C6.55228 12 7 12.4477 7 13C7 13.5523 6.55228 14 6 14H5C4.44772 14 4 13.5523 4 13ZM9 12C8.44772 12 8 12.4477 8 13C8 13.5523 8.44772 14 9 14H10C10.5523 14 11 13.5523 11 13C11 12.4477 10.5523 12 10 12H9Z"
        fill={color}
      ></path>
    </svg>,
  ];

  const rtl = [
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      key={0}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 6C3 4.34315 4.34315 3 6 3H16C16.3788 3 16.725 3.214 16.8944 3.55279C17.0638 3.89157 17.0273 4.29698 16.8 4.6L14.25 8L16.8 11.4C17.0273 11.703 17.0638 12.1084 16.8944 12.4472C16.725 12.786 16.3788 13 16 13H6C5.44772 13 5 13.4477 5 14V17C5 17.5523 4.55228 18 4 18C3.44772 18 3 17.5523 3 17V6Z"
        fill={color}
      ></path>
    </svg>,
  ];

  const administrators = [
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      key={0}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18 10C18 14.4183 14.4183 18 10 18C5.58172 18 2 14.4183 2 10C2 5.58172 5.58172 2 10 2C14.4183 2 18 5.58172 18 10ZM12 7C12 8.10457 11.1046 9 10 9C8.89543 9 8 8.10457 8 7C8 5.89543 8.89543 5 10 5C11.1046 5 12 5.89543 12 7ZM9.99993 11C7.98239 11 6.24394 12.195 5.45374 13.9157C6.55403 15.192 8.18265 16 9.99998 16C11.8173 16 13.4459 15.1921 14.5462 13.9158C13.756 12.195 12.0175 11 9.99993 11Z"
        fill={color}
      ></path>
    </svg>,
  ];

  const addUser = <UserAddOutlined />;

  const locations = <FolderViewOutlined />;
  const addLocation = <FolderAddOutlined />;

  const addCompany = <PlusSquareOutlined />;
  const companies = <UnorderedListOutlined />;

  const addClient = <AppstoreAddOutlined />;
  const clients = <ShopOutlined />;

  const reports = <FileProtectOutlined />;

  const signin = [
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      key={0}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 2C5.44772 2 5 2.44772 5 3V4H4C2.89543 4 2 4.89543 2 6V16C2 17.1046 2.89543 18 4 18H16C17.1046 18 18 17.1046 18 16V6C18 4.89543 17.1046 4 16 4H15V3C15 2.44772 14.5523 2 14 2C13.4477 2 13 2.44772 13 3V4H7V3C7 2.44772 6.55228 2 6 2ZM6 7C5.44772 7 5 7.44772 5 8C5 8.55228 5.44772 9 6 9H14C14.5523 9 15 8.55228 15 8C15 7.44772 14.5523 7 14 7H6Z"
        fill={color}
      ></path>
    </svg>,
  ];

  const signup = [
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      key={0}
    >
      <path
        d="M0,2A2,2,0,0,1,2,0H8a2,2,0,0,1,2,2V8a2,2,0,0,1-2,2H2A2,2,0,0,1,0,8Z"
        transform="translate(4 4)"
        fill={color}
      />
      <path
        d="M2,0A2,2,0,0,0,0,2V8a2,2,0,0,0,2,2V4A2,2,0,0,1,4,2h6A2,2,0,0,0,8,0Z"
        fill={color}
      />
    </svg>,
  ];

  return (
    <>
      <Link to="/dashboard" className="brand">
        <img style={{ width: "80px", height: "auto" }} src={logo} alt="logo" />
        <span>C M S</span>
      </Link>
      <hr
        style={{
          padding: "0px",
          margin: "6px 0 6px 0",
        }}
      />
      <Menu theme="light" mode="inline">
        <Menu.Item key="1">
          <NavLink to="/dashboard">
            <span
              className="icon"
              style={{
                background: page === "dashboard" ? color : "",
                width: "26px",
                height: "26px",
              }}
            >
              {dashboard}
            </span>
            <span className="label">Dashboard</span>
          </NavLink>
        </Menu.Item>
        <hr
          style={{
            padding: "0px",
            margin: "6px 0 6px 0",
          }}
        />

        <Menu.Item key="2">
          <NavLink to="/users">
            <span
              className="icon"
              style={{
                background: page === "users" ? color : "",
                width: "26px",
                height: "26px",
              }}
            >
              {tables}
            </span>
            <span className="label">Users</span>
          </NavLink>
        </Menu.Item>
        <Menu.Item key="3">
          <NavLink to="/administrators">
            <span
              className="icon"
              style={{
                background: page === "administrators" ? color : "",
                width: "26px",
                height: "26px",
              }}
            >
              {administrators}
            </span>
            <span className="label">Administrators</span>
          </NavLink>
        </Menu.Item>
        <Menu.Item key="4">
          <NavLink to="/add-user">
            <span
              className="icon"
              style={{
                background: page === "add-user" ? color : "",
                width: "26px",
                height: "26px",
              }}
            >
              {addUser}
            </span>
            <span className="label">Add User</span>
          </NavLink>
        </Menu.Item>
        <hr
          style={{
            padding: "0px",
            margin: "6px 0 6px 0",
          }}
        />

        <Menu.Item key="5">
          <NavLink to="/locations">
            <span
              className="icon"
              style={{
                background: page === "locations" ? color : "",
                width: "26px",
                height: "26px",
              }}
            >
              {locations}
            </span>
            <span className="label">Locations</span>
          </NavLink>
        </Menu.Item>

        <Menu.Item key="6">
          <NavLink to="/add-location">
            <span
              className="icon"
              style={{
                background: page === "add-location" ? color : "",
                width: "26px",
                height: "26px",
              }}
            >
              {addLocation}
            </span>
            <span className="label">Add Location</span>
          </NavLink>
        </Menu.Item>
        <hr
          style={{
            padding: "0px",
            margin: "6px 0 6px 0",
          }}
        />

        <Menu.Item key="7">
          <NavLink to="/companies">
            <span
              className="icon"
              style={{
                background: page === "companies" ? color : "",
                width: "26px",
                height: "26px",
              }}
            >
              {companies}
            </span>
            <span className="label">Companies</span>
          </NavLink>
        </Menu.Item>

        <Menu.Item key="8">
          <NavLink to="/add-company">
            <span
              className="icon"
              style={{
                background: page === "add-company" ? color : "",
                width: "26px",
                height: "26px",
              }}
            >
              {addCompany}
            </span>
            <span className="label">Add Company</span>
          </NavLink>
        </Menu.Item>
        <hr
          style={{
            padding: "0px",
            margin: "6px 0 6px 0",
          }}
        />

        <Menu.Item key="9">
          <NavLink to="/clients">
            <span
              className="icon"
              style={{
                background: page === "clients" ? color : "",
                width: "26px",
                height: "26px",
              }}
            >
              {clients}
            </span>
            <span className="label">Clients</span>
          </NavLink>
        </Menu.Item>

        <Menu.Item key="10">
          <NavLink to="/add-client">
            <span
              className="icon"
              style={{
                background: page === "add-client" ? color : "",
                width: "26px",
                height: "26px",
              }}
            >
              {addClient}
            </span>
            <span className="label">Add Client</span>
          </NavLink>
        </Menu.Item>
        <hr
          style={{
            padding: "0px",
            margin: "6px 0 6px 0",
          }}
        />

        <Menu.Item key="11">
          <NavLink to="/reports">
            <span
              className="icon"
              style={{
                background: page === "reports" ? color : "",
                width: "26px",
                height: "26px",
              }}
            >
              {reports}
            </span>
            <span className="label">Reports</span>
          </NavLink>
        </Menu.Item>

        {/*<Menu.Item key="12">*/}
        {/*  <NavLink to="/reports-paged">*/}
        {/*    <span*/}
        {/*      className="icon"*/}
        {/*      style={{*/}
        {/*        background: page === "reports-paged" ? color : "",*/}
        {/*        width: "26px",*/}
        {/*        height: "26px",*/}
        {/*      }}*/}
        {/*    >*/}
        {/*      {reports}*/}
        {/*    </span>*/}
        {/*    <span className="label">Reports Paged</span>*/}
        {/*  </NavLink>*/}
        {/*</Menu.Item>*/}
      </Menu>
    </>
  );
}

export default Sidenav;
